import React from "react";
import { Typography } from "antd";
import Header from "../../components/Header";

const { Title, Paragraph } = Typography;

const StubPage = ({ title, image }) => (
  <div>
    <Header activePath="" />
    <div style={{
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
    }}>
      <div style={{ textAlign: 'center', padding: 40 }}>
        <Title level={2} style={{ color: '#1a1a2e', marginBottom: 16 }}>{title}</Title>
        {image ? (
          <img src={image} alt={title} style={{ maxWidth: 400, borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: 32 }} />
        ) : (
          <Paragraph style={{ color: '#666', fontSize: 16, marginBottom: 32 }}>
            页面制作中，敬请期待
          </Paragraph>
        )}
      </div>
    </div>
  </div>
);

export default StubPage;
